module.exports = __webpack_public_path__ + "img/contract-active.fb040b49.svg";